export default __webpack_public_path__ + "static/media/hotel_staff.cbfb4ca2.svg";